import { applicationActions, divaActions } from '../actions';

export const createApplicationReducer =
  (initialState = {}) =>
  (state = initialState, action) => {
    switch (action.type) {
      case applicationActions.PUT_APPLICATION:

      case divaActions.UPDATE_DETAILS:
        if (action.payload) {
          if (state.applicationId) {
            return {
              applicationId: state.applicationId,
              ...action.payload,
            };
          }

          return action.payload;
        }

        return {};

      default:
        return state;
    }
  };

export default createApplicationReducer;
